export type PublicEnvKey =
  | 'VITE_V2_API_URL'
  | 'VITE_V1_API_URL'
  | 'VITE_PAYMENT_API_URL'
  | 'VITE_ENABLE_TOSS_ONBOARDING_RESET';

export type PublicEnv = Record<PublicEnvKey, string> & {
  NODE_ENV: string;
  VERSION: string;
};

const PUBLIC_ENV_KEYS: PublicEnvKey[] = [
  'VITE_V2_API_URL',
  'VITE_V1_API_URL',
  'VITE_PAYMENT_API_URL',
  'VITE_ENABLE_TOSS_ONBOARDING_RESET',
];

function readProcessEnv(key: string): string {
  const env = process.env;

  return env[key] || '';
}

export function getPublicEnv(): PublicEnv {
  return PUBLIC_ENV_KEYS.reduce(
    (env, key) => {
      env[key] = readProcessEnv(key);

      return env;
    },
    {
      NODE_ENV: readProcessEnv('NODE_ENV') || 'development',
      VERSION: readProcessEnv('VERSION'),
    } as PublicEnv,
  );
}

export function getPublicEnvValue(key: PublicEnvKey): string {
  return getPublicEnv()[key];
}

export function getNodeEnv(): string {
  return getPublicEnv().NODE_ENV;
}
